(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    if (!sections.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        section.classList.add('scroll-reveal', 'is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section, index) {
      section.classList.add('scroll-reveal');
      if (index === 0) {
        section.classList.add('is-visible');
        return;
      }
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
